import {colors} from "@c10h/colors";
import NextImage from "@components/NextImage";
import {Btn} from "@components/V5Comp";
import {useTranslation} from "ni18n";
import React from "react";

import useMediaQuery from "../../../useMediaQuery";

const Hero = (): JSX.Element => {
  const i18n = useTranslation();
  const isMd = useMediaQuery("md");

  return (
    <div className="bg-lightMint maxw-72 pt40 pb14 ph4 pt28-md">
      <div className="maxw90 ma">
        <div className="df gg5 fdc-md aic-md">
          <div className="dn db-md">
            <NextImage
              priority
              src="/CovidReadyCompliance/herom1"
              extension="png"
              width="614"
              height="514"
              alt={i18n.t(
                "Custom vaccine and testing dashboard and mobile view of an employee’s vaccination records",
              )}
            />
          </div>
          <div style={{marginLeft: -100}} className="dn-md">
            <NextImage
              priority
              src="/CovidReadyCompliance/hero1"
              extension="png"
              width="870"
              height="631"
              alt={i18n.t(
                "Custom vaccine and testing dashboard and mobile view of an employee’s vaccination records",
              )}
            />
          </div>

          <div className="fx pt12 pr16 pt2-md pr0-md">
            <h2 className="fs48 lh12 fs28-md">
              {i18n.t("Keep your employees safe and your company in COVID-19 compliance")}
            </h2>
            <div className="mt2">
              <Btn
                href="#get-started"
                className="mr3 mb3 focus-bsDarkBlue3 fs12-f-xs event-Kv3M6e"
                aria-label={i18n.t("Request a Demo")}
                hoverBg={colors.gray600}
              >
                {i18n.t("Request a Demo")}
              </Btn>
            </div>

            <div className="mt12 lh18 mt2-md ">
              <ul>
                {[
                  i18n.t("Secure & HIPAA compliant"),
                  i18n.t("Custom vaccine & testing dashboard"),
                  isMd
                    ? i18n.t("Manage exemptions")
                    : i18n.t("Manage medical & religious exemptions"),
                  i18n.t("On-demand testing & symptom tracking"),
                  i18n.t("Medical oversight from a trusted healthcare provider"),
                ].map(l => (
                  <li key={l} className="mt4 df mt6-md">
                    <span className="cIcon-check mt2" />
                    <span className="font-isb ml2">{l}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="tac">
          <div className="mt10 dig gg20 aic gtc3fr-md gafd-f-md gg4-md">
            {[
              {name: "brookfield", altText: "Brookfield", width: 102, height: 15},
              {name: "oakland-athletics", altText: "Oakland Athletics", width: 55, height: 55},
              {name: "alto", altText: "Alto", width: 125, height: 58},
              {name: "bolt-threads", altText: "Bolt Threads", width: 117, height: 37},
              {
                name: "the-city-county-of-san-francisco",
                altText: "The City County of San Francisco",
                width: 187,
                height: 60,
              },
              {
                name: "county-of-los-angeles",
                altText: "County of Los Angeles",
                width: 137,
                height: 60,
              },
            ].map(({name, altText, width, height}) => {
              const ratio = isMd ? 1.5 : 1;
              return (
                <div key={name} className="">
                  <NextImage
                    src={`/CovidReadyCompliance/${name}`}
                    alt={altText}
                    width={width / ratio}
                    height={height / ratio}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Hero;
